import { CheckIcon, RadioUncheckedIcon } from '@truvhq/ui';
import { clsx } from 'clsx';

import type { ChecklistStep } from 'entities/onboarding/types';

/** Where the step stands, as the tick or circle at the head of its row. */
export function StepMarker({ status }: { status: ChecklistStep['status'] }) {
  if (status === 'complete') {
    return (
      <div
        role="img"
        aria-label="Completed"
        className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success text-white"
      >
        <CheckIcon width={12} height={12} aria-hidden />
      </div>
    );
  }

  return (
    <RadioUncheckedIcon
      role="img"
      aria-label={status === 'skipped' ? 'Skipped' : 'Not done'}
      className={clsx('h-5 w-5 shrink-0', status === 'skipped' ? 'text-grey30' : 'text-grey40')}
    />
  );
}
